"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Assess_exports = {};
__export(Assess_exports, {
  default: () => Assess_default
});
module.exports = __toCommonJS(Assess_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.70703 5.50391C7.77214 5.41276 7.79818 5.30859 7.78516 5.19141C7.77214 5.07422 7.72005 4.98307 7.62891 4.91797C7.53776 4.85286 7.43359 4.82682 7.31641 4.83984C7.19922 4.85286 7.10807 4.90495 7.04297 4.99609L6.00781 6.38281L5.48047 6.12891C5.3763 6.07682 5.26562 6.07031 5.14844 6.10938C5.04427 6.14844 4.96615 6.21354 4.91406 6.30469C4.86198 6.40885 4.85547 6.51953 4.89453 6.63672C4.93359 6.74089 5.00521 6.81901 5.10938 6.87109L5.92969 7.28125C6.02083 7.33333 6.11198 7.34635 6.20312 7.32031C6.30729 7.29427 6.39193 7.24219 6.45703 7.16406L7.70703 5.50391ZM9.54297 5.17188H14.3477L15.3828 4.13672C15.7604 3.75911 16.2096 3.55729 16.7305 3.53125C17.2513 3.50521 17.7135 3.65495 18.1172 3.98047C18.599 4.35807 18.8529 4.85286 18.8789 5.46484C18.918 6.07682 18.7227 6.60417 18.293 7.04688L16.418 8.92188V14.8398C16.418 15.4388 16.2031 15.9531 15.7734 16.3828C15.3568 16.7995 14.849 17.0078 14.25 17.0078H6.75C6.15104 17.0078 5.63672 16.7995 5.20703 16.3828C4.79036 15.9531 4.58203 15.4388 4.58203 14.8398V8.92188C4.11328 8.6224 3.72917 8.22526 3.42969 7.73047C3.14323 7.23568 3 6.6888 3 6.08984C3 5.16536 3.32552 4.3776 3.97656 3.72656C4.6276 3.07552 5.41536 2.75 6.33984 2.75C7.09505 2.75 7.76562 2.97786 8.35156 3.43359C8.95052 3.88932 9.34766 4.46875 9.54297 5.17188ZM8.66406 6.08984C8.66406 5.4388 8.4362 4.88542 7.98047 4.42969C7.52474 3.97396 6.97786 3.74609 6.33984 3.74609C5.6888 3.74609 5.13542 3.97396 4.67969 4.42969C4.22396 4.88542 3.99609 5.4388 3.99609 6.08984C3.99609 6.72786 4.22396 7.27474 4.67969 7.73047C5.13542 8.1862 5.6888 8.41406 6.33984 8.41406C6.97786 8.41406 7.52474 8.1862 7.98047 7.73047C8.4362 7.27474 8.66406 6.72786 8.66406 6.08984ZM9.66016 6.16797C9.64714 7.06641 9.3151 7.83464 8.66406 8.47266C8.01302 9.09766 7.23828 9.41016 6.33984 9.41016C6.20964 9.41016 6.07943 9.40365 5.94922 9.39062C5.83203 9.3776 5.70833 9.35807 5.57812 9.33203V14.8398C5.57812 15.1523 5.6888 15.4258 5.91016 15.6602C6.14453 15.8815 6.42448 15.9922 6.75 15.9922H14.25C14.5755 15.9922 14.849 15.8815 15.0703 15.6602C15.3047 15.4258 15.4219 15.1523 15.4219 14.8398V9.91797L13.3516 11.9883C13.1432 12.1966 12.9089 12.3724 12.6484 12.5156C12.401 12.6589 12.1406 12.7695 11.8672 12.8477L10.4219 13.2383C10.1224 13.3164 9.86198 13.2578 9.64062 13.0625C9.41927 12.8542 9.33464 12.6003 9.38672 12.3008L9.64062 10.7578C9.69271 10.4193 9.79688 10.0938 9.95312 9.78125C10.1224 9.46875 10.3242 9.19531 10.5586 8.96094L13.3516 6.16797H9.66016ZM10.4023 12.2031L11.5938 11.8906C11.7891 11.8255 11.9714 11.7474 12.1406 11.6562C12.3229 11.5521 12.4857 11.4284 12.6289 11.2852L16.2227 7.69141L14.7383 6.20703L11.2812 9.66406C11.099 9.83333 10.9492 10.0286 10.832 10.25C10.7279 10.4583 10.6562 10.6862 10.6172 10.9336L10.4023 12.2031ZM17.5898 6.32422C17.8112 6.10286 17.9089 5.83594 17.8828 5.52344C17.8698 5.21094 17.7396 4.95703 17.4922 4.76172C17.2839 4.59245 17.043 4.51432 16.7695 4.52734C16.5091 4.54036 16.2812 4.64453 16.0859 4.83984L15.3242 5.62109L16.8086 7.10547L17.5898 6.32422Z",
      fill: "currentColor"
    }
  )
);
const SvgAssess = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Assess_default = SvgAssess;
